module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門2_4_5.6ab953bc.png";